module.exports = __webpack_public_path__ + "static/img/scheme_text.e46d15bd.png";